module.exports = __webpack_public_path__ + "static/media/gallery_preview.b10e18d7.png";